<template>
	<div style="padding-top:100px;">
    <!-- start hero -->
    <div id="hero" class="jarallax" data-speed="0.7" data-img-position="50% 55%" style="background-image: url(img/O7MF460.jpg);">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-7">
            <h1 class="__title">Sucursales</h1>
          </div>
        </div>
      </div>
    </div>
    <!-- end hero -->

    <main role="main">
      <link rel="stylesheet" href="css/style.min.css" type="text/css">

      <!-- start section -->
      <section class="section">
        <div class="container">
          <div class="section-heading section-heading--center">
            <h2 class="__title">Donde necesites <span>efectividad</span></h2>

            <p class="text-content">Ahí estaremos para atenderte, con toda la calidad que nos distingue.</p>
          </div>

          <!-- <div>
            <img class="img-fluid" src="./../assets/img/img_country_map.png" alt="demo" />
          </div> -->


          <div>
            <div class="modal-sucursal container boxsu" style="background-color: #f1f1f1;opacity: 0.8;padding:20px;">
              <a href="##" onclick="$('.modal-sucursal').hide('fast');" id="close">
                <i class="fa fa-close" aria-hidden="true"></i>
              </a>
              <div class="col-xs-12" align="left">
                <h4 id="sucursal" class="sucursal">
                  Culiacán
                </h4>
                <p id="dir" class="dir">
                  Calle Industrial 4 Lote 44B, La Primavera, Culiacán, Sinaloa. C.P. 80199
                </p>
                <p id="contact-person" class="contact-person">
                  Persona de contacto: Hugo Felix
                </p>
                <p id="contact-email" class="contact-email">
                  Correo electrónico: ventas@agrobiosol.com.mx
                </p>
                <p id="contact-phone" class="contact-phone">
                  Teléfono de oficina: (668) 811-87-00
                </p>

              </div>
            </div>
            <img id="map" class="img-responsive" data-animation="animated fadeInRight" src="./../assets/img/img_country_map.png" alt="#" style="margin-left: 15.5%;width: 65%;" usemap="#mapa">
            <map id="mapa" name="mapa">
              <area coords="670,755,30" shape="circle" alt="1">
              <area coords="716,853,30" shape="circle" alt="2">
              <area coords="625,685,30" shape="circle" alt="3">
              <area coords="596,639,30" shape="circle" alt="4">
              <area coords="844,1131,30" shape="circle" alt="5">
              <area coords="1010,577,30" shape="circle" alt="6">
              <area coords="450,407,30" shape="circle" alt="7">
              <area coords="170,64,30" shape="circle" alt="8">
              <area coords="152,261,30" shape="circle" alt="9">
              <area coords="349,587,30" shape="circle" alt="10">
              <area coords="448,801,30" shape="circle" alt="11">
              <area coords="679,787,30" shape="circle" alt="12">
            </map>

          </div>

        </div>
      </section>
      <!-- end section -->
      <Contact />
    </main>
  </div>
</template>

<script>
import Map from '@/components/Map.vue'
import Contact from '@/components/Contact.vue'
import Modal from '@/components/Modal.vue'
import axios from 'axios'

export default {
  components: {
    Map,
    Contact,
    Modal
  },
  mounted () {

$(document).ready(function (e) {

    $('#test').css('color', 'red')

    $('img[usemap]').rwdImageMaps();

    $('area').on('click', function () {
        console.log($(this).attr('alt'));

        $("#numap").text($(this).attr('alt'));
        $(".modal-sucursal").hide("fast");
        $(".modal-sucursal").show("fast");

        switch ($(this).attr('alt')) {
            case "1":
                $(".sucursal").text("Culiacán");
                $(".dir").html("Calle Industrial 4 Lote 44B, La Primavera, Culiacán, Sinaloa. C.P. 80199");
                $(".contact-person").html("Persona de contacto: Hugo Felix");
                $(".contact-email").html("Correo electrónico: ventas@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (667) 760-37-40");
                break;

            case "2":
                $(".sucursal").text("El Rosario");
                $(".dir").html("Callejon Santa Simona 10, Col. Centro, El Rosario, Sinaloa. C.P. 82800");
                $(".contact-person").html("Persona de contacto: Cesar Leon");
                $(".contact-email").html("Correo electrónico: ing.rendon@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (694) 952-01-93");
                break;

            case "3":
                $(".sucursal").text("Guasave");
                $(".dir").html("Calle Nuevo Leon S/N entre Av. Cuitzeo y Manzana 20, Col. Stase, Guasave, Sinaloa. C.P. 81029");
                $(".contact-person").html("Persona de contacto: Ricardo Luna");
                $(".contact-email").html("Correo electrónico: ventas.guasave@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (687) 871-38-83");
                break;
            case "4":
                $(".sucursal").text("Los Mochis");
                $(".dir").html("Blvd. Adolfo Lopez Mateos 3306, Col. Miguel Hidalgo, Los Mochis Ahome, Sinaloa. C.P. 81210");
                $(".contact-person").html("Persona de contacto: Mauricio Roman");
                $(".contact-email").html("Correo electrónico: ventas.mochis@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (668) 811-87-00");
                break;
            case "5":
                $(".sucursal").text("Cd. Guzmán");
                $(".dir").html("Bloque A, Bodega 8, Central de Abastos, Ciudad Guzmán, Zapotlan el Grande, Jalisco. C.P. 49000");
                $(".contact-person").html("Persona de contacto: José Orozco");
                $(".contact-email").html("Correo electrónico: admin.cdguzman@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (341) 410-69-32");
                break;
            case "6":
                $(".sucursal").text("Torreón");
                $(".dir").html("Antigua Carretera San Pedro 765 Bodega 10, Col. Paso del Aguila, Torreón, Coahuila. C.P. 27410");
                $(".contact-person").html("Persona de contacto: José Humberto Garcia");
                $(".contact-email").html("Correo electrónico: jhgarcia@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (871) 688-21-88");
                break;
            case "7":
                $(".sucursal").text("Ciudad Obregón");
                $(".dir").html("Dr. Norman E. Borlaug 6917 sur, Col. El Roble, Cd. Obregón, Sonora. C.P. 85190");
                $(".contact-person").html("Persona de contacto: Ing. Martin Méndez");
                $(".contact-email").html("Correo electrónico: ing.mendez@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (644) 204-12-74");
                break;
            case "8":
                $(".sucursal").text("Mexicali");
                $(".dir").html("Lazaro Cardenas Local 4X, Ejido Hermosillo, Baja California. C.P. 21840");
                $(".contact-person").html("Persona de contacto: Mauricio Tolosa");
                $(".contact-email").html("Correo electrónico: ing.tolosa@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (686) 220-62-21");
                break;
            case "9":
                $(".sucursal").text("Camalú");
                $(".dir").html("Calle Benito Juarez 1702, Col. Zuñiga, Camalu Ensenada, B.C. C.P 22910");
                $(".contact-person").html("Persona de contacto: Jesus Jacobo");
                $(".contact-email").html("Correo electrónico: jhgarcia@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (116) 165-55-75");
                break;
            case "10":
                $(".sucursal").text("Cd. Constitución");
                $(".dir").html("Carretera Transpeninsular KM 212, Col. Vargas, Cd. Constitución, BCS. C.P. 23630");
                $(".contact-person").html("Persona de contacto: Gibran Perez");
                $(".contact-email").html("Correo electrónico: ing.perez@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (613) 111-02-98");
                break;
            case "11":
                $(".sucursal").text("La Paz");
                $(".dir").html("Blvd. Forjadores De SudCalifornia, Carretera al sur km 7, Local 1, Col. Tabachines, La Paz, BCS. C.P. 23084");
                $(".contact-person").html("Persona de contacto: Luis Quintero");
                $(".contact-email").html("Correo electrónico: admin.lapaz@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (612) 121-44-26");
                break;
            case "12":
                $(".sucursal").text("La Cruz, Elota");
                $(".dir").html("Carretera La Cruz-Culiacán Km 1.25 Plaza Montebello Local #14");
                $(".contact-person").html("Persona de contacto: Ing. Guadalupe Perea");
                $(".contact-email").html("Correo electrónico: ventas.lacruz@agrobiosol.com.mx");
                $(".contact-phone").html("Teléfono de oficina: (667) 503-39-85");
                break;
        }
    });
});

/*
* rwdImageMaps jQuery plugin v1.6
*
* Allows image maps to be used in a responsive design by recalculating the area coordinates to match the actual image size on load and window.resize
*
* Copyright (c) 2016 Matt Stow
* https://github.com/stowball/jQuery-rwdImageMaps
* http://mattstow.com
* Licensed under the MIT license
*/
;(function($) {
  $.fn.rwdImageMaps = function() {
    var $img = this;

    var rwdImageMap = function() {
      $img.each(function() {
        if (typeof($(this).attr('usemap')) == 'undefined')
          return;

        var that = this,
          $that = $(that);

        // Since WebKit doesn't know the height until after the image has loaded, perform everything in an onload copy
        $('<img />').on('load', function() {
          var attrW = 'width',
            attrH = 'height',
            w = $that.attr(attrW),
            h = $that.attr(attrH);

          if (!w || !h) {
            var temp = new Image();
            temp.src = $that.attr('src');
            if (!w)
              w = temp.width;
            if (!h)
              h = temp.height;
          }

          var wPercent = $that.width()/100,
            hPercent = $that.height()/100,
            map = $that.attr('usemap').replace('#', ''),
            c = 'coords';

          $('map[name="' + map + '"]').find('area').each(function() {
            var $this = $(this);
            if (!$this.data(c))
              $this.data(c, $this.attr(c));

            var coords = $this.data(c).split(','),
              coordsPercent = new Array(coords.length);

            for (var i = 0; i < coordsPercent.length; ++i) {
              if (i % 2 === 0)
                coordsPercent[i] = parseInt(((coords[i]/w)*100)*wPercent);
              else
                coordsPercent[i] = parseInt(((coords[i]/h)*100)*hPercent);
            }
            $this.attr(c, coordsPercent.toString());
          });
        }).attr('src', $that.attr('src'));
      });
    };
    $(window).resize(rwdImageMap).trigger('resize');

    return this;
  };
})(jQuery);


  }
  };
</script>

<style>
  .modal-sucursal {
    position: absolute;
    margin-top: 0%;
    left: 52% !important;
    width: 45% !important;
  }
</style>